import styled from "styled-components";

export const LineThroughText = styled.span`
    text-decoration: line-through;
`;

export const ThumbnailWrapper = styled.div`
    .thumbnail__container {
        display: flex;
        flex-flow: column;
        align-items: center;
        max-width: 100px;
        padding: 5px;
    }

    .thumbnail__image {
        border-radius: 5px;
        margin-bottom: 5px;
        object-fit: contain;
        width: 50px;
        height: 50px;
        box-shadow: 1px 1px 5px #0000001f;
    }
`;
